module.exports = __webpack_public_path__ + "img/MPHC_vista.74522384.jpg";